import { useState } from 'react'
import { supabase } from '../supabaseClient'
import { useAuth } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom'
import Navbar from '../components/Navbar'

export default function NewTask() {
  const { profile } = useAuth()
  const navigate = useNavigate()
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [instructions, setInstructions] = useState('')
  const [file, setFile] = useState(null)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    setSaving(true)
    setError('')
    let media_url = null

    if (file) {
      const ext = file.name.split('.').pop()
      const filename = Date.now() + '.' + ext
      const { error: uploadError } = await supabase.storage.from('exercises').upload(filename, file)
      if (uploadError) { setError(uploadError.message); setSaving(false); return }
      const { data: urlData } = supabase.storage.from('exercises').getPublicUrl(filename)
      media_url = urlData.publicUrl
    }

    const { error: insertError } = await supabase.from('interventions').insert({
      clinic_id: profile.clinic_id, title, description, instructions, media_url
    })

    if (insertError) { setError(insertError.message); setSaving(false); return }
    navigate('/clinician/interventions')
  }

  return (
    <>
      <Navbar />
      <div className="page">
        <span onClick={() => navigate('/clinician/interventions')} className="back-link" style={{ cursor: 'pointer' }}>← Task library</span>
        <div className="page-header">
          <h1>New task</h1>
          <p>Add an task to your library</p>
        </div>

        {error && <div className="alert-error" style={{ marginBottom: '1.5rem' }}>{error}</div>}

        <div className="card">
          <form onSubmit={handleSubmit} className="form-group">
            <div className="form-field">
              <label className="form-label">Task title</label>
              <input placeholder="e.g. Ice therapy" value={title} onChange={e => setTitle(e.target.value)} required />
            </div>
            <div className="form-field">
              <label className="form-label">Short description</label>
              <textarea placeholder="Brief summary" value={description} onChange={e => setDescription(e.target.value)} rows={2} style={{ resize: 'vertical' }} />
            </div>
            <div className="form-field">
              <label className="form-label">Instructions</label>
              <textarea placeholder="Step-by-step instructions..." value={instructions} onChange={e => setInstructions(e.target.value)} rows={5} style={{ resize: 'vertical' }} />
            </div>
            <div className="form-field">
              <label className="form-label">Image (optional)</label>
              <input type="file" accept="image/png,image/jpeg" onChange={e => setFile(e.target.files[0])} />
              <p style={{ fontSize: 12, color: 'var(--text-tertiary)', marginTop: 4 }}>PNG or JPG recommended</p>
            </div>
            <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
              <button type="submit" disabled={saving} style={{ flex: 1, padding: 14 }}>
                {saving ? 'Saving...' : 'Save task'}
              </button>
              <button type="button" className="secondary" onClick={() => navigate('/clinician/interventions')} style={{ padding: 14 }}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}
